var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPutOnCart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.112,
    height: 20,
    viewBox: "0 0 20.112 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#69b64a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1317.216,790.094a2,2,0,1,0,2,2A2,2,0,0,0,1317.216,790.094Zm10,0a2,2,0,1,0,2,2A2,2,0,0,0,1327.216,790.094Zm-2-5a2.385,2.385,0,0,0,2-1l4-6c.371-.663-.237-2-1-2h-15l-1-2h-3v2h2l3,8-1,2a2.142,2.142,0,0,0,2,3h12v-2h-12l1-2Zm-9-7h12l-3,5h-7Z",
    transform: "translate(-1311.216 -774.094)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPutOnCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/putOnCart.ca4a4f31.svg";
export { ForwardRef as ReactComponent };